<nav class="navbar navbar-expand-lg bg-light bg-body-tertiary shadow p-0">
  <div class="container-fluid">
    <img class="navbar-brand p-0 pe-2 m-0" [routerLink]="[navLinks[0].path]" src="main/webapp/assets/images/garpa.svg" style="height: 45px">
    <button class="navbar-toggler ms-auto me-3"
      type="button"
      (click)="isMenuCollapsed = !isMenuCollapsed"
      aria-label="Navigation"
      data-target="#navbarContent"
      aria-controls="navbarContent"
      [attr.aria-expanded]="!isMenuCollapsed">
      &#9776;
    </button>
    <div [ngbCollapse]="isMenuCollapsed" class="collapse navbar-collapse" id="navbarContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        @for (link of navLinks; track link) {
          @if (link.subLinks.length===0) {
            <li class="nav-item">
              <a [routerLink]="[link.path]" class="nav-link">{{link.text}}</a>
            </li>
          }
          @if (link.subLinks.length>0) {
            <li class="nav-item" ngbDropdown>
              <a [id]="'id' + link.id" class="nav-link" ngbDropdownToggle role="button" tabindex="0"> {{link.text}} </a>
              <div class="dropdown-menu" ngbDropdownMenu>
                @for (sublink of link.subLinks; track sublink) {
                  <a [routerLink]="['app',sublink.path]"
                  ngbDropdownItem>{{sublink.text}}</a>
                }
              </div>
            </li>
          }
        }
        <li>
          <a class="btn btn-outline-secondary" href="#" (click)="logout()">
            <i class="bi bi-box-arrow-right" aria-hidden="true"></i> Logout
          </a>
        </li>
      </ul>

    </div>
    <div> {{ account?.username }}</div>
  </div>
</nav>

